import { AddressTypeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { AddressType } from '@/services/graphql/types';

export const mapperAddressTyperDataEnum = createEnumMapperFunction(
  AddressType,
  AddressTypeDataEnum
);
